<template lang="pug">
.int-card
  img(src="~assets/icons/exps/int.jpg")
  .copy
    .line 总榜排名
    .data
      span.no NO.
      span.rank {{rank}}
</template>
<script>
export default {
  name: 'ForestCard',
  props: {
    exp: {},
  },
  data() {
    return {}
  },
  computed: {
    rank() {
      return JSON.parse(this.exp.data).rank + 1
    },
  },
  methods: {},
  mounted() {
    console.log(777, this.exp)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.int-card
  width: 100%
  height: 100%
  img
    width: 100%
    height: 100%
    object-fit: cover
  .copy
    position: absolute
    bottom: pxToRem(30)
    left: pxToRem(38)
    .line
      font-size: 16px
    .data
      line-height: 48px
      span
        font-family: $ff-number-big
        font-weight: 300
      .no
        font-size: 48px
      .rank
        font-size: 64px
</style>
